var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4620_32954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0577 6.17956C22.0453 5.5316 22.0336 4.91947 22.0336 4.32728C22.0336 3.86335 21.6576 3.48722 21.1935 3.48722C17.6008 3.48722 14.8655 2.45473 12.5855 0.237863C12.2593 -0.0793438 11.7402 -0.0792318 11.4142 0.237863C9.13437 2.45473 6.39947 3.48722 2.80703 3.48722C2.34309 3.48722 1.96697 3.86335 1.96697 4.32728C1.96697 4.91958 1.95532 5.53193 1.94289 6.18001C1.82774 12.2101 1.67003 20.4686 11.7247 23.9537C11.8138 23.9846 11.9068 24.0001 11.9998 24.0001C12.0927 24.0001 12.1858 23.9846 12.2749 23.9537C22.3303 20.4685 22.1728 12.2098 22.0577 6.17956ZM11.9999 22.2685C3.3767 19.136 3.50708 12.2738 3.62278 6.21205C3.62973 5.84824 3.63645 5.49564 3.64115 5.14998C7.00588 5.00796 9.69654 3.98835 11.9999 1.98183C14.3034 3.98835 16.9945 5.00807 20.3595 5.14998C20.3642 5.49553 20.3709 5.84791 20.3779 6.21149C20.4935 12.2735 20.6237 19.1359 11.9999 22.2685Z",
    fill: "#545B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8926 9.08169L10.838 13.1361L9.10784 11.4059C8.77977 11.0779 8.24784 11.0779 7.91988 11.4059C7.59181 11.734 7.59181 12.2659 7.91988 12.5939L10.2441 14.9181C10.408 15.0821 10.6231 15.1641 10.838 15.1641C11.053 15.1641 11.268 15.0821 11.432 14.9181L16.0805 10.2698C16.4086 9.94169 16.4086 9.40976 16.0806 9.0818C15.7526 8.75373 15.2207 8.75362 14.8926 9.08169Z",
    fill: "#545B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4620_32954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.e5b09a9848d64b2f41a6ef4fec9900ce.svg";
export { ForwardRef as ReactComponent };